import styled, { css } from 'styled-components';

export const Container = styled.div<{
  containerType?: 'section' | 'subsection';
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 16px 0px 16px;

  @media (min-width: 768px) {
    padding: 0px 24px 0px 24px;
  }

  ${({ containerType }) =>
    containerType === 'subsection' &&
    css`
      @media (min-width: 992px) {
        margin: 72px 0px 0px 88px;
        padding: 0px;
      }
    `}

  ${({ containerType }) =>
    containerType === 'section' &&
    css`
      @media (min-width: 992px) {
        margin: 72px 0px 0px 88px;
        padding: 0px 32px 0px 32px;
      }

      @media (min-width: 1281px) {
        margin: 72px 0px 0px 88px;
      }
    `}

  > div {
    width: 100%;

    ${({ containerType }) =>
      containerType === 'section' &&
      css`
        @media (min-width: 1281px) {
          width: 1128px;
        }
      `}

    ${({ containerType }) =>
      containerType === 'subsection' &&
      css`
        @media (min-width: 992px) {
          width: 696px;
        }

        @media (min-width: 1280px) {
          width: 744px;
        }
      `}
  }
`;
